import { render } from "./EmailBindModal.vue?vue&type=template&id=5f415c37&scoped=true"
import script from "./EmailBindModal.vue?vue&type=script&lang=js"
export * from "./EmailBindModal.vue?vue&type=script&lang=js"

import "./EmailBindModal.vue?vue&type=style&index=0&id=5f415c37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f415c37"]])

export default __exports__